/** Clear student auth storage (same keys as Profile logout). */
export function clearStudentAuthSession() {
    localStorage.removeItem('token');
    localStorage.removeItem('id');
    sessionStorage.removeItem('student_verify_auto_resend');
}

/** Full navigation to login — avoids React router redirect loop with NotAuthProvider. */
export function redirectToStudentLogin() {
    clearStudentAuthSession();
    sessionStorage.setItem('student_force_login', '1');
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    window.location.replace(`${base}/login`);
}
